<script>

import Popover from 'primevue/popover';
import FileBrowser from "@/components/FileBrowser.vue";
import fileHelper from "@/mixins/fileHelper.js";
import FileBrowserUpload from "@/components/FileBrowserUpload.vue";
import FileBrowserUploadDescription from "@/components/FileBrowserUploadDescription.vue";

export default {
  components: {
    FileBrowserUploadDescription,
    FileBrowserUpload,
    FileBrowser
  },
  mixins: [
    fileHelper,
  ],
  props: {
    drupal_input_id: {
      type: String,
      required: true
    },
    entity_type: {
      type: String,
      required: false
    },
    bundle: {
      type: String,
      required: false
    },
    field_name: {
      type: String,
      required: false
    },
    file_allowed_extensions: {
      type: String,
      required: false,
      default: 'jpg jpeg png gif pdf doc docx xls xlsx ppt pptx zip'
    },
    file_max_size: {
      type: Number,
      required: false,
      default: 1024 * 1024 * 10
    },
  },
  async mounted() {
    // Check if drupal_input_id already has a value
    const element = this.drupalInputElement();
    if (element.value) {
      const files = JSON.parse(element.value);
      // Loop over the files
      for (const file of files) {
        this.addFile(file);
      }
    }
  },
  data () {
    return {
      files: [],
      fileBrowserDialog: false,
    }
  },
  computed: {

  },
  watch: {
    files: {
      handler(newValue, oldValue) {
        const element = this.drupalInputElement();
        // Convert to JSON
        // Set value in the Drupal DOM input element
        element.value = JSON.stringify(this.files);
      },
      deep: true
    },
  },
  methods: {
    openFileBrowserDialog() {
      this.fileBrowserDialog = true;
    },
    closeFileBrowserDialog() {
      this.fileBrowserDialog = false;
    },
    filesSelected(files_selected) {
      for (const file of files_selected) {
        this.addFile(file);
      }
      // Close the dialog
      this.closeFileBrowserDialog();
    },
    addFile(file) {
      this.files.push(file);
    },
    removeFile(file) {
      // Find the file in the array and remove it
      const index = this.files.findIndex(f => f.id === file.id);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
    },
    drupalInputElement() {
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupal_input_id;
      const element = document.querySelector(element_id);
      return element;
    },
    openUploadDialog() {
      this.$refs.fileBrowserUpload.openDialog();
    },
    uploadSuccess(files) {
      for (const file of files) {
        this.addFile(file);
      }
      // Close the modal
      this.$refs.fileBrowserUpload.closeDialog();
    },
    toggleAttachmentMenu(event) {
      this.$refs.attachmentPopover.toggle(event);
    },
  },
}
</script>


<template>

  <DataTable size="small" :value="files" class="datatable-no-header" tableStyle="min-width: 50rem" >

    <template v-if="files.length">
      <Column field="name" headerStyle="display: none">
        <template #body="{ data }">
          <a :href="data.url" target="_blank">{{ data.name }}</a>
        </template>
      </Column>
      <Column field="size" headerStyle="display: none">
        <template #body="{ data }">
          {{ formatSize(data.size) }}
        </template>
      </Column>
      <Column headerStyle="display: none">
        <template #body="{ data }">
          <Button @click="removeFile(data)" severity="danger">
            <i class="fas fa-times"></i>
          </Button>
        </template>
      </Column>
    </template>

    <template #footer>
      <Button type="button" icon="fas fa-paperclip" label="Bijlage toevoegen" outlined @click="toggleAttachmentMenu" class="min-w-48" />
      <Popover ref="attachmentPopover" style="width: 300px">
          <Button fluid label="Selecteer van computer" icon="fas fa-desktop" v-if="entity_type && bundle && field_name" text size="small" @click="openUploadDialog" />
          <Button fluid label="Online bestandenverkenner" icon="fas fa-folder-open" text size="small" @click="openFileBrowserDialog" />
      </Popover>
    </template>
  </DataTable>


  <!-- File browser dialog -->
  <Dialog v-model:visible="fileBrowserDialog" modal maximizable header="Selecteer bestand" :style="{ width: '70rem' }" :contentStyle="{ height: '900px' }">
    <FileBrowser :file-select="true" @on-file-select="filesSelected"></FileBrowser>
  </Dialog>

  <!-- Upload new temp files (without attaching them to folders)  -->
  <FileBrowserUpload
    v-if="entity_type && bundle && field_name"
    :file-upload-url="'/api/entity-file-upload/' + entity_type + '/' + bundle + '/' + field_name"
    :file-allowed-extensions="file_allowed_extensions"
    :file-max-size="file_max_size"
    ref="fileBrowserUpload"
    @upload-success="uploadSuccess"
  ></FileBrowserUpload>

  <FileBrowserUploadDescription v-if="files.length" :file-allowed-extensions="file_allowed_extensions" :file-max-size="file_max_size"></FileBrowserUploadDescription>

</template>

<style>
  .datatable-no-header thead {
    display: none;
  }
</style>
